import type { AdvisoryTljDraft } from "@/lib/cosmos-api";

const csvCell = (value: string | number | undefined | null): string => {
  const text = value === undefined || value === null ? "" : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** LMS ingestion payload: the CreateJourneyCommand plus the assignment intent. */
export const draftIngestionJson = (draft: AdvisoryTljDraft): string =>
  JSON.stringify(
    {
      createJourneyCommand: draft.createJourneyCommand,
      journeyAssignmentIntent: draft.assignmentIntent,
      todos: draft.todos,
      generatedBy: "AIHR.Cosmos Advisory",
      draftId: draft.id,
      generatedAt: draft.createdAt
    },
    null,
    2
  );

/** Master-Doc-style CSV: one row per structure item, then optional resources. */
export const draftMasterDocCsv = (draft: AdvisoryTljDraft): string => {
  const header = [
    "Section",
    "Phase",
    "Item",
    "Type",
    "Catalog id",
    "SKU",
    "Duration (min)",
    "URL",
    "Rationale"
  ];
  const rows: string[][] = draft.structureItems.map((item) => [
    "Journey structure",
    item.phase ?? "Additional",
    item.title,
    item.elementType,
    String(item.elementId),
    item.sku ?? "",
    item.durationMinutes !== undefined ? String(item.durationMinutes) : "",
    item.url ?? "",
    item.why
  ]);
  for (const resource of draft.supportingResources) {
    rows.push([
      "Optional resources",
      "",
      resource.title,
      resource.entityType,
      resource.id,
      "",
      "",
      resource.url ?? "",
      resource.why
    ]);
  }
  return [header, ...rows].map((row) => row.map(csvCell).join(",")).join("\n");
};

export const downloadTextFile = (
  filename: string,
  content: string,
  mimeType: string
): void => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
};

export const draftFileStem = (draft: AdvisoryTljDraft): string =>
  (draft.createJourneyCommand.SKU || `tlj-${draft.id.slice(0, 8)}`).toLowerCase();
